(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate', '$uiRouterGlobals'];

    function translationHandler($rootScope, $window, $state, $translate, $uiRouterGlobals) {
        return {
            initialize: initialize,
            updateTitle: updateTitle,
            isRTL: isRTL
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
                updatePageDirection();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $uiRouterGlobals.current.data && $uiRouterGlobals.current.data.pageTitle) {
                titleKey = $uiRouterGlobals.current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }

        function updatePageDirection() {
            var currentLang = $translate.proposedLanguage() || $translate.use();
            angular.element('html').attr('lang', currentLang);
            angular.element('html').attr('dir', isRTL(currentLang) ? 'rtl' : 'ltr');
        }

        function isRTL(langKey) {
            if (langKey === 'ar' ||
                langKey === 'fa' ||
                langKey === 'iw' ||
                langKey === 'he') {
                return true;
            }
            return false;
        }
    }
})();
